import { DEFAULT_CURRENCY_CODE, normalizeCurrencyCode, type CurrencyCode } from '@klear/constants/currency'
import { Money, type MoneyFormatOptions } from '@klear/money'
import isFinite from 'lodash/isFinite'
import round from 'lodash/round'

export const toCurrencyCode = (value: unknown, fallback: CurrencyCode = DEFAULT_CURRENCY_CODE): CurrencyCode =>
  normalizeCurrencyCode(value) ?? fallback

const NON_FINITE_LABEL = '—'

const moneyForDisplay = (amountMinor: number, currency: CurrencyCode): Money | undefined => {
  const rounded = round(amountMinor)
  if (!isFinite(rounded)) return undefined
  return Money.fromMinorUnits(BigInt(rounded), toCurrencyCode(currency))
}

export const moneyFormatterFor = (currency: CurrencyCode) => {
  const normalizedCurrency = toCurrencyCode(currency)
  return (amountMinor: number, options: MoneyFormatOptions = {}): string =>
    moneyForDisplay(amountMinor, normalizedCurrency)?.toString(options) ?? NON_FINITE_LABEL
}
